import { z } from '@harvestiq/zod';
import {
  lgmCoverageTableSchema,
  lrpCoverageTableSchema,
} from '../../coverages/coverage-details-email-table';

export const submitAipCoverageFailureDataSchema = z
  .object({
    agentMgmtLink: z.string(),
    reasons: z.string().array().optional(),
    lrpEndorsementTableData: lrpCoverageTableSchema.optional(),
    lgmEndorsementTableData: lgmCoverageTableSchema.optional(),
  })
  .refine(
    (data) => data.lrpEndorsementTableData || data.lgmEndorsementTableData,
    {
      message:
        'Either lrpEndorsementTableData or lgmEndorsementTableData must be provided',
    }
  );

export type SubmitAipCoverageFailureData = z.infer<
  typeof submitAipCoverageFailureDataSchema
>;
